import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'

export default createListViewComponent({
  entityName: entityNames.formGroups,
  createButtonTextId: 'createFormGroup',
  primaryLinkTarget: 'formGroupRecord',
})()
